export default __webpack_public_path__ + "static/media/7.c2d15d66.jpg";